var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighlighterActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_358_13852",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_358_13852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 35.6877H20.0002C16.8994 35.6877 14.0033 34.7837 11.5639 33.2285C13.3058 30.2191 16.4845 28.3688 20.0002 28.3688C23.5159 28.3688 26.6947 30.2191 28.4365 33.2287C25.919 34.8359 22.9918 35.6904 20.0005 35.6877ZM25.1615 16.4739V8.77351C25.1615 8.09142 24.8105 7.4656 24.2423 7.11293L24.2423 7.11289L24.2378 7.11018C23.6591 6.76297 22.9379 6.72 22.3276 7.03404C22.3269 7.0344 22.3262 7.03477 22.3255 7.03513L15.9179 10.2389C15.2446 10.5577 14.8388 11.2462 14.8388 11.9811V16.4739C13.9292 16.6399 13.2351 17.4402 13.2351 18.3961V26.2421C11.3525 27.3166 9.7318 28.8251 8.53519 30.7059C5.82046 27.809 4.30646 23.9817 4.31243 20.0004V19.9999C4.31243 11.3564 11.3567 4.31219 20.0002 4.31219C28.6437 4.31219 35.6879 11.3564 35.6879 19.9999C35.6879 24.1378 34.0892 27.8971 31.4644 30.7056C30.2862 28.8577 28.6733 27.3246 26.7653 26.2415V18.3961C26.7653 17.4402 26.0711 16.6399 25.1615 16.4739ZM20.0002 0.404639C9.18989 0.404639 0.404883 9.18964 0.404883 19.9999C0.404883 30.8102 9.18989 39.5952 20.0002 39.5952C30.8104 39.5952 39.5954 30.8102 39.5954 19.9999C39.5954 9.18964 30.8104 0.404639 20.0002 0.404639ZM22.8577 20.3499V24.4612H17.1426V20.3499H22.8577ZM18.7464 16.4424V13.1917L21.2539 11.9379V16.4424H18.7464Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlighterActive);
export default __webpack_public_path__ + "static/media/highlighter_active.c01ebfe39b28b805bb100a5c75cb19d9.svg";
export { ForwardRef as ReactComponent };